/* global axios */
import ApiClient from './ApiClient';

class SearchAPI extends ApiClient {
  constructor() {
    super('search', { accountScoped: true });
  }

  get({ q }) {
    return axios.get(this.url, {
      params: {
        q,
      },
    });
  }

  contacts({ q }) {
    return axios.get(`${this.url}/contacts`, {
      params: {
        q,
      },
    });
  }

  conversations({ q }) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        q,
      },
    });
  }

  messages({ q, page = 1, cursor }) {
    return axios.get(`${this.url}/messages`, {
      params: {
        q,
        page,
        cursor_id: cursor?.id,
        cursor_created_at: cursor?.created_at,
      },
    });
  }
}

export default new SearchAPI();
